'use client';

import { createTheme } from '@mui/material/styles';
import { pink } from '@mui/material/colors';

// Generate our theme
const BiologistexTheme = createTheme({
  palette: {
    primary: {
      light: '#ABD2FA',
      main: '#4392F1',
      dark: '#3E78B2',
    },
    secondary: pink,
  },
  typography: {
    useNextVariants: true,
  },
});

export default BiologistexTheme;
